export const ERROR_LOGS_SUCCESS = 'ERROR_LOGS_SUCCESS';
export const MESSAGE_LOGS_SUCCESS = 'MESSAGE_LOGS_SUCCESS';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
